module.exports = __webpack_public_path__ + "img/home-shebei-3.ce96e6a8.png";